import { useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import MyProfileAddressSkeleton from "../../../Skeleton/myWallet/myProfileAddressSkeleton";

export const BillingAddressCard = () => {
  const { billingAddressOriginal } = useContext(GlobalContext);
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(billingAddressOriginal);
  }, [billingAddressOriginal]);
  return (
    <div className="col-sm-6 mt-3 mt-sm-0">
      <div className="card order-address-card">
        <div className="card-header">
          <h5>
            <span className="wes wes-home" />
            Billing Address
          </h5>
        </div>
        {data ? (
          <div className="card-body order-address-body">
            <div className="row">
              <div className="col-lg-12">
                <div className="addressDetails">
                  <address className="text-dark">
                    <b>{data.billTo}</b>
                    <br />
                    {data.billAttention},
                    <br />
                    {data.billAddress1},
                    <br />
                    {data.billAddress2 && (
                      <>
                        {data.billAddress2}
                        <br />,
                      </>
                    )}
                    {data.billSuburb},
                    <br />
                    {data.billState}-{data.billZip}, {data.billCountry}
                  </address>
                  <div className="addressDetails-contact mt-3">
                    <p>
                      <b>Phone Number:</b> {data.billPhone}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <MyProfileAddressSkeleton />
        )}
      </div>
    </div>
  );
};
